import React from "react";

import { LogoRow as Value } from "@reactivated";

import { ImageChooserBlock } from "@thelabnyc/thelabui/src/components/ImageChooserBlock";

import { Themed } from "../../styles/themes";

import styles from "./index.module.scss";

export const LogoRow = ({
    value: { theme, block_label, images },
}: {
    value: Value;
}) => {
    if (!images || images.length < 1) return <></>;

    return (
        <Themed
            theme={theme}
            tag="section"
            aria-label={block_label ?? undefined}
        >
            <ul className={styles.list}>
                {images.map((image, index) => (
                    <li key={index} className={styles.item}>
                        <ImageChooserBlock
                            value={image}
                            sizes="200px"
                            imageAttrs={{ className: styles.image }}
                        />
                    </li>
                ))}
            </ul>
        </Themed>
    );
};
